import NavigationItems from "./NavigationItems";

const DropDown = (props) => {
    let hide;
    if (!props.open) hide = "hidden";

    return (
        <div className={`${hide} w-full md:hidden pb-2 md:pb-4  px-6 sm:px-10`}>
            <div className="max-w-xs mx-auto">
                <NavigationItems
                    dropDownHandler={props.dropDownHandler}
                    calledBy="dropdown"
                />
            </div>
        </div>
    );
};

export default DropDown;
